// extracted by mini-css-extract-plugin
module.exports = {"LocationContainer":"Location_LocationContainer__Fijja"};